import React from 'react';
import { connect } from 'react-redux';
import PatientTemplate from './patient_availability';
import { getPatientLocationsById } from './actions/PatientActions';

class PatientLocation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      patientLocationsList: [],
      selectedLocationId: null,
    };
}



  componentWillMount() {
    this.props.getPatientLocationsById(this.props.patientId);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.patientLocationsList && nextProps.patientLocationsList !== this.props.patientLocationsList) {
      let patientLocationsList = nextProps.patientLocationsList.data;
      this.setState({
        patientLocationsList,
      });
      if(patientLocationsList.length > 0 && patientLocationsList[0].clientLocationID){
        this.setState({
          selectedLocationId: patientLocationsList[0].clientLocationID
        })
      }
    }
  }

renderLocations = (location) =>{
    return(
      <p style={{textAlign:'center'}}>
        {location[0] && location[0].locationName}
      </p>
    )
  }

  render() {
    return (
      <div>
       <div className="readmin-panel crop appoint">
        <div className="row">
          {this.renderLocations(this.state.patientLocationsList)}
        </div>
       </div>
          <PatientTemplate
           selectedLocationId = {this.state.selectedLocationId}
           patientId={ this.props.patientId} 
           patientLocationsList = {this.state.patientLocationsList}
          />
      </div>
    );
  }
}


const mapStateToProps = (state) => {
 return {
    patientLocationsList: state.patient.patientLocationsList,
};
};  

export default connect(mapStateToProps, { getPatientLocationsById })(PatientLocation);



// WEBPACK FOOTER //
// ./src/modules/patients/patientLocation.js